import React, {useState} from "react";
import I18n from 'i18n.js.erb'
import PlaceholderImage from "./PlaceholderImage";
import { isPresent, setImgTagHeight, setImgTagWidth } from "../../utils/utils";
import TextOverlayOnImage from "./TextOverlayOnImage";
import FlawsInspectorModal from "../../backoffice/components/FlawsInspectorModal";

const ShowBlueprintImageFrontImage = ({
  size,
  product,
  blueprintImage,
  handleShowLargeImage,
  cursor,
  additionalClasses,
  hidePlaceHolderText,
  isBackImage,
  renderCarouselImageIndex,
  carouselImageType,
  textOverlayPlaceholder,
  containerCssClassList,
  setFlawsToInspect
}) => {

  return (
    <React.Fragment>
      {
        !isPresent(renderCarouselImageIndex) ?
          (blueprintImage[`${size}_${isBackImage ? 'back_' : ''}image_url`] ?
            <div>
              <div className={isPresent(containerCssClassList) ? containerCssClassList : 'd-flex justify-content-center position-relative text-center'}
                   style={{ maxHeight: setImgTagHeight(size), maxWidth: setImgTagWidth(size) }}>
                <img src={blueprintImage[`${size}_${isBackImage ? 'back_' : ''}image_url`]}
                     alt=""
                     className={`${additionalClasses ? additionalClasses : ''}`}
                     height={setImgTagHeight(size)}
                     width={setImgTagWidth(size)}
                     style={{ cursor: cursor ? cursor : 'zoom-in' }}
                     onClick={(e) => {
                       if (handleShowLargeImage)
                         handleShowLargeImage(e, product ? product : blueprintImage, blueprintImage, isBackImage ? 'back' : '')
                     }}
                />

                {
                  !blueprintImage.encasing_id &&
                  <TextOverlayOnImage
                    textOverlay={size !== 'thumb' ? I18n.t('js.common.notGradableProduct') : I18n.t('js.common.notGradableProductShort')}
                    size={size}
                    type={'red-overlay'}
                  />
                }
              </div>

              {
                setFlawsToInspect && blueprintImage.flaws?.filter(flaw => flaw.flaws_detected)?.length > 0 &&
                  <p className="mb-0 mt-1 color-aig-blue cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      setFlawsToInspect(
                        blueprintImage.flaws.map(flawsByImageType => {
                          return {
                            ...flawsByImageType,
                            rectangles: JSON.parse(flawsByImageType.rectangles)
                          }
                        })
                      );
                    }}
                  >
                    <small>View Flaws</small>
                  </p>
              }
            </div>
            :
            <PlaceholderImage
              size={size}
              hidePlaceHolderText={hidePlaceHolderText}
              textOverlay={textOverlayPlaceholder}
              additionalClasses={`${additionalClasses ? additionalClasses : ''}`}
              showNotGradableProductOverlay={!blueprintImage.encasing_id}
            />)
          :
          (blueprintImage[`${size}_carousel_images_urls`] &&
            blueprintImage[`${size}_carousel_images_urls`][renderCarouselImageIndex] &&
            blueprintImage[`${size}_carousel_images_urls`][renderCarouselImageIndex][`${size}_${carouselImageType}_url`] ?
            <div className="d-flex justify-content-center position-relative text-center"
              style={{ maxHeight: setImgTagHeight(size), maxWidth: setImgTagWidth(size) }}>
              <img src={blueprintImage[`${size}_carousel_images_urls`][renderCarouselImageIndex][`${size}_${carouselImageType}_url`]}
                alt=""
                className={`${additionalClasses ? additionalClasses : ''}`}
                height={setImgTagHeight(size)}
                width={setImgTagWidth(size)}
                style={{ cursor: cursor ? cursor : 'zoom-in' }}
                onClick={(e) => {
                  if (handleShowLargeImage)
                    handleShowLargeImage(e, product ? product : blueprintImage, blueprintImage, isBackImage ? 'back' : '')
                }
                }
              />

              {
                !blueprintImage.encasing_id &&
                <TextOverlayOnImage
                  textOverlay={size !== 'thumb' ? I18n.t('js.common.notGradableProduct') : I18n.t('js.common.notGradableProductShort')}
                  size={size}
                  type={'red-overlay'}
                />
              }
            </div>
            :
            <PlaceholderImage
              size={size}
              hidePlaceHolderText={hidePlaceHolderText}
              textOverlay={textOverlayPlaceholder}
              showNotGradableProductOverlay={!blueprintImage.encasing_id}
            />
          )
      }
    </React.Fragment>
  )
}

export default ShowBlueprintImageFrontImage;